/* Recent bekeken (productpagina 2.0, fase P5).

   Twee taken: het huidige product onthouden, en de eerder bekeken producten
   tonen. De lijst staat in localStorage van de bezoeker; Shopify weet er
   niets van en hoeft dat ook niet.

   De kaarten komen via de Section Rendering API uit het thema zelf, zodat
   er geen tweede opmaak in JavaScript ontstaat en de prijs altijd klopt. */
(function () {
  var SLEUTEL = 'ck_recent_bekeken';
  var MAX_ONTHOUDEN = 12;

  function lees() {
    try {
      var ruw = window.localStorage.getItem(SLEUTEL);
      var lijst = ruw ? JSON.parse(ruw) : [];
      return Array.isArray(lijst) ? lijst : [];
    } catch (e) {
      /* Prive-venster of geblokkeerde opslag: dan gewoon geen geschiedenis. */
      return [];
    }
  }

  function schrijf(lijst) {
    try {
      window.localStorage.setItem(SLEUTEL, JSON.stringify(lijst));
    } catch (e) {
      /* Stil laten mislukken; de pagina moet gewoon werken. */
    }
  }

  function huidigeHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  /* 1. Onthouden. Vooraan zetten, dubbelen eruit, lijst afkappen. */
  var handle = huidigeHandle();
  var lijst = lees();
  if (handle) {
    lijst = lijst.filter(function (h) { return h !== handle; });
    lijst.unshift(handle);
    schrijf(lijst.slice(0, MAX_ONTHOUDEN));
  }

  /* 2. Tonen. Het huidige product hoort er niet bij: daar sta je al op. */
  var blok = document.querySelector('[data-ck-recent]');
  if (!blok) return;

  var doel = blok.querySelector('[data-ck-recent-lijst]');
  if (!doel) return;

  var script = document.querySelector('script[data-ck-max]');
  var max = script ? parseInt(script.getAttribute('data-ck-max'), 10) : 4;
  if (isNaN(max) || max < 1) max = 4;

  var tonen = lees().filter(function (h) { return h !== handle; }).slice(0, max);
  if (!tonen.length) return;

  /* Na de eerste paint ophalen, zodat dit de laadtijd niet raakt. */
  function haalOp() {
    var opgehaald = 0;

    tonen.forEach(function (h, volgorde) {
      fetch('/products/' + encodeURIComponent(h) + '?section_id=ck-recent-kaart')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html || !html.trim()) return;

          var houder = document.createElement('div');
          houder.innerHTML = html.trim();
          var kaart = houder.firstElementChild;
          if (!kaart) return;

          /* De volgorde van de antwoorden ligt niet vast, dus zetten we hem
             met order terug naar de vololgorde van de lijst. */
          kaart.style.order = volgorde;
          doel.appendChild(kaart);

          opgehaald += 1;
          if (opgehaald === 1) blok.hidden = false;
        })
        .catch(function () {});
    });
  }

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(haalOp, { timeout: 2000 });
  } else {
    window.setTimeout(haalOp, 600);
  }
})();
